import { ServicesQuery } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const servicesHandler = graphql.query<ServicesQuery>(
  "services",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        services: {
          dxf: {
            redirectURL: "http://localhost:8080/dxf",
            using: true,
          },
          invoice: {
            redirectURL: "http://localhost:8080/invoice",
            using: true,
          },
          bfm: {
            redirectURL: "http://localhost:8080/bfm",
            using: false,
          },
          loan: {
            redirectURL: "http://localhost:8080/loan",
            using: true,
          },
        },
      },
    });
  }
);
